"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../../../Atoms/Text/Text"));
var _HeaderNav = require("./HeaderNav2025.style");
var _MenuGroupIcon = _interopRequireDefault(require("./Menu-Group-Icon.svg"));
const HeaderNavItem2025 = _ref => {
  let {
    thisID,
    relNoopener,
    hasSubMenu,
    index,
    openedSubMenu,
    isNotDesktop,
    hasPopUp,
    thisUrl,
    toggleSubMenu,
    group,
    thisFirstChild,
    navHelper,
    internalLinkHelper,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_HeaderNav.NavItem, {
    role: "none",
    key: `${index}-${thisID}--item`,
    index: index,
    isSubMenuOpen: !!openedSubMenu
  }, isNotDesktop ? /*#__PURE__*/_react.default.createElement(_HeaderNav.NavLink, {
    href: hasPopUp ? '#' : thisUrl,
    inline: true,
    rel: relNoopener,
    "aria-expanded": !!openedSubMenu[thisID],
    "aria-haspopup": hasPopUp,
    onClick: hasPopUp ? e => toggleSubMenu(e, thisID) : null,
    role: "button",
    key: `${index}-${thisID}--link`,
    isExpanded: !!openedSubMenu[thisID]
  }, thisFirstChild.title, hasSubMenu && /*#__PURE__*/_react.default.createElement(_HeaderNav.ChevronWrapper, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _MenuGroupIcon.default,
    alt: "chevron down icon"
  }))) : /*#__PURE__*/_react.default.createElement(_HeaderNav.StyledText, null, /*#__PURE__*/_react.default.createElement(_HeaderNav.DesktopNavLink, Object.assign({
    href: thisUrl,
    inline: true,
    rel: relNoopener,
    "aria-haspopup": hasPopUp,
    key: `${index}-${thisID}`,
    hasSubMenu: hasSubMenu
  }, rest), thisFirstChild.title, hasSubMenu && /*#__PURE__*/_react.default.createElement(_HeaderNav.ChevronWrapper, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _MenuGroupIcon.default,
    alt: "chevron down icon"
  })))), hasSubMenu && /*#__PURE__*/_react.default.createElement(_HeaderNav.SubNavMenu, {
    role: "list",
    isSubMenuOpen: !!openedSubMenu[thisID],
    key: `${index}-${thisID}--sub-item`
  }, group.links.map((child, childIndex) => {
    let thisSubUrl = navHelper(child);
    thisSubUrl = internalLinkHelper(thisSubUrl);

    // Skip the very first child on desktop, since
    // we've already made a 'button' version above:
    if (childIndex === 0 && !isNotDesktop) return null;

    // Otherwise, render out as usual:
    return /*#__PURE__*/_react.default.createElement(_HeaderNav.SubNavItem, {
      key: `${index}-${thisSubUrl}`
    }, /*#__PURE__*/_react.default.createElement(_HeaderNav.SubNavLink, {
      href: thisSubUrl,
      inline: true,
      role: "menuitem"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, null, child.title)));
  })));
};
var _default = exports.default = HeaderNavItem2025;